import { createAction } from '@reduxjs/toolkit';
import { GET_DICTIONARIES_COMPETENCE_CATEGORIES } from '../actionConstants';

export const getAllCompetenceCategories = createAction(
  GET_DICTIONARIES_COMPETENCE_CATEGORIES
);
